import React from 'react';

import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { CompanyDescriptionExecSum } from './CompanyDescriptionExecSum';
import { FinancialInfoExecSum } from './FinancialInfoExecSum';
import { FinancingNeedsExecSum } from './FinancingNeedsExecSum';
import { GoalsExecSum } from './GoalsExecSum';
import { MarketExecSum } from './MarketExecSum';
import { OrganizationExecSum } from './OrganizationExecSum';
import { ProductsExecSum } from './ProductsExecSum';
import { IForInvestorFormSubSections } from '../forInvestorsSections';

const SUB_SECTIONS: IForInvestorFormSubSections = {
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY.GOALS_AND_OBJECTIVES]: GoalsExecSum,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY.COMPANY_DESCRIPTION]: CompanyDescriptionExecSum,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES]: ProductsExecSum,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY.MARKET_AND_CUSTOMERS]: MarketExecSum,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY.ORGANIZATION_AND_TEAM]: OrganizationExecSum,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY.FINANCIAL_INFORMATION]: FinancialInfoExecSum,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY.FINANCING_NEEDS]: FinancingNeedsExecSum,
};

export const ExecutiveSummary: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
